<div class="list-builder-container">
  <ng-container>
    <div class="row">
      <ng-container *ngFor="let col of layout; let i = index">
        <div class="{{ getColClass(col) }}">
          <ng-template
            [ngTemplateOutlet]="ContentCreator"
            [ngTemplateOutletContext]="{ col: col }"
          ></ng-template>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<ng-template #LinkItem let-col="col">
  <span>{{ col.link.label }}</span>
  <span
    *ngIf="col.link.iconClass"
    id="{{ col.link.iconId }}"
    class="{{ col.link.iconClass }}"
  ></span>
  <div class="link-content" *ngIf="col.link.template">
    <ng-template [ngTemplateOutlet]="col.link.template"></ng-template>
  </div>
</ng-template>
<ng-template #ContentCreator let-col="col">
  <div class="header-headline" *ngIf="col.headline">
    {{ col.headline }}
  </div>
  <div class="header-textbox" *ngIf="col.text">
    {{ col.text }}
  </div>
  <div class="header-link" *ngIf="col.link">
    <a
      *ngIf="col.link.url"
      href="{{ col.link.url }}"
      target="{{ col.link.target ? col.link.target : '_blank' }}"
      [ngClass]="col.link?.class"
      tooltip="{{ col.link?.tooltip }}"
      [placement]="getTooltipPosition(col)"
    >
      <ng-template
        [ngTemplateOutlet]="LinkItem"
        [ngTemplateOutletContext]="{ col: col }"
      ></ng-template>
    </a>
    <a
      *ngIf="col.link.routerLink"
      [routerLink]="[col.link.routerLink]"
      [routerLinkActive]="['active']"
      [ngClass]="col.link?.class"
      tooltip="{{ col.link?.tooltip }}"
      [placement]="getTooltipPosition(col)"
    >
      <ng-template
        [ngTemplateOutlet]="LinkItem"
        [ngTemplateOutletContext]="{ col: col }"
      ></ng-template>
    </a>
    <a
      *ngIf="!col.link.url && !col.link.routerLink && col.link.clickEvent"
      [ngClass]="col.link?.class"
      (click)="emitEvent(col.link.clickEvent)"
      tooltip="{{ col.link?.tooltip }}"
      [placement]="getTooltipPosition(col)"
    >
      <ng-template
        [ngTemplateOutlet]="LinkItem"
        [ngTemplateOutletContext]="{ col: col }"
      ></ng-template>
    </a>
    <a
      *ngIf="!col.link.url && !col.link.routerLink && !col.link.clickEvent"
      [ngClass]="col.link?.class"
      tooltip="{{ col.link?.tooltip }}"
      [placement]="getTooltipPosition(col)"
    >
      <ng-template
        [ngTemplateOutlet]="LinkItem"
        [ngTemplateOutletContext]="{ col: col }"
      ></ng-template>
    </a>
  </div>
  <div class="header-list" *ngIf="col.list">
    <ul>
      <ng-container *ngFor="let listItem of col.list">
        <li *ngIf="listItem" class="{{ listItem.class }}">
          <ng-template
            [ngTemplateOutlet]="ContentCreator"
            [ngTemplateOutletContext]="{ col: listItem }"
          ></ng-template>
        </li>
      </ng-container>
    </ul>
  </div>
  <div class="header-template" *ngIf="col?.template">
    <ng-template [ngTemplateOutlet]="col.template"></ng-template>
  </div>
</ng-template>
